<template>
    <div class="business-content-main add-accessories" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="section" v-if="Type != '3'">
            <div class="btns">
                <el-button size="small" type="primary" class="search-btn" @click="submitData">提交</el-button>
            </div>
            <div class="form-main">
                <el-form :rules="rules" :model="partData" ref="partData" label-width="80px" class="form-ctn">
                    <div class="form-main">
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="标题" prop="Title">
                                    <el-input v-model="partData.Title" class="search-item" size="medium"
                                        placeholder="请输入打包标题"></el-input>
                                </el-form-item>
                            </div>
                            <div class="form-item form-item-content">
                                <el-form-item label="打包要求" prop="Content">
                                    <quill-editor class="editor" v-model="partData.Content" ref="myQuillEditor"
                                        :options="editorOption" @change="onEditorChange($event)">
                                    </quill-editor>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="上传视频">
                                    <el-upload 
                                        ref="uploadRef"
                                        action="#"
                                        :on-exceed="handleExceed"
                                        :headers="headerObj"
                                        :show-file-list="false"
                                        accept="video/mp4,video/ogg,video/flv,video/avi,video/mov"
                                        :http-request="handleCustomUpload"
                                        :on-remove="handleTempVideoRemove"
                                    >
                                        <el-button size="small" class="search-btn btn-primary" >上传视频</el-button>
                                    </el-upload>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="" class="video-item">
                                    <div class="videoimg" 
                                         v-for="(item,index) in [...tempVideoList, ...videoList]" 
                                         :key="index"
                                         :data-type="item.isTemp ? 'temp' : 'uploaded'"
                                    >
                                        <i class="el-icon-error" @click="delUpUrl(index, item.isTemp)"></i>
                                        <video 
                                            :src="item.isTemp ? item.tempUrl : (downloadUrl + item.FileUrl)" 
                                            @click="openVideoVisible(item.isTemp ? item.tempUrl : (downloadUrl + item.FileUrl))"
                                        ></video>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="适用配件">
                                    <el-button size="small" class="search-btn btn-primary"
                                        @click="openVisible">添加适用配件</el-button>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="">
                                    <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="goodsList" border
                                        style="width: 100%">
                                        <el-table-column prop="APCode" label="汽配编码"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="GoodCode" label="互换码"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="GoodName" label="汽配名称"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column width="320px" prop="AutoSerise" label="适用车型"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column width="120px" label="操作">
                                            <template slot-scope="scope">
                                                <div class="ops-ctn">
                                                    <el-button size="mini" style="color: red" @click="del(scope.row)"
                                                        type="text">移除</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="check" v-else>
            <div class="form-main">
                <el-form :rules="rules" :model="partData" ref="partData" label-width="80px" class="form-ctn">
                    <div class="form-main">
                        <div class="form-line">
                            <div class="form-item">
                                <el-form-item label="">
                                    <div class="check-titile">{{ partData.Title }}</div>
                                </el-form-item>
                            </div>
                            <div class="form-item">
                                <el-form-item label="打包要求">
                                    <div class="check-content">
                                        <div v-html="partData.Content"></div>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="form-item" v-if="videoList.length > 0">
                                <el-form-item label="视频" class="video-item">
                                    <div class="videoimg" v-for="(item,index) in videoList" :key="index">
                                        <video :src="downloadUrl + item.FileUrl" @click="openVideoVisible(downloadUrl + item.FileUrl)"></video>
                                    </div>
                                </el-form-item>
                            </div>
                            <div class="form-item" v-if="goodsList.length > 0">
                                <el-form-item label="适用配件">
                                    <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="goodsList" border
                                        style="width: 100%">
                                        <el-table-column prop="APCode" label="汽配编码"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="GoodCode" label="互换码"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column prop="GoodName" label="汽配名称"
                                            show-overflow-tooltip></el-table-column>
                                        <el-table-column width="320px" prop="AutoSerise" label="适用车型"
                                            show-overflow-tooltip></el-table-column>
                                    </el-table>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="添加商品" :visible.sync="visible" width="1200px">
            <div class="dialog-content" v-if="visible">
                <div class="search" v-loading="loading">
                    <div class="search-left">
                        <div class="flex">
                            <div class="search-name">汽配编码</div>
                            <el-input class="search-item" size="small" v-model="searchData.APCode"
                                placeholder="请输入"></el-input>
                        </div>
                        <div class="flex">
                            <div class="search-name">汽配名称</div>
                            <el-input class="search-item" size="small" v-model="searchData.GoodName"
                                placeholder="请输入"></el-input>
                        </div>
                        <div class="flex">
                            <div class="search-name">适用车型</div>
                            <el-input class="search-item" size="small" v-model="searchData.AutoSerise"
                                placeholder="请输入"></el-input>
                        </div>
                        <div class="flex">
                            <div class="search-name">汽配分类</div>
                            <el-select size="small" class="search-item" v-model="searchData.Cate" multiple collapse-tags
                                filterable clearable @visible-change="getGoodsType($event)">
                                <el-option v-for="optionItem in typeList" :key="optionItem.Value"
                                    :label="optionItem.Text" :value="optionItem.Value">
                                    <div class="option-content">
                                        <div>{{ optionItem.Text }}</div>
                                    </div>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex">
                            <div class="search-name">品牌</div>
                            <el-select v-model="searchData.BrandName" multiple collapse-tags filterable clearable
                                size="small" class="search-item" @visible-change="getGoodsBrand($event)">
                                <el-option :key="item.Text" v-for="item in brandList" :label="item.Text"
                                    :value="item.Text"></el-option>
                            </el-select>
                        </div>
                        <div class="flex">
                            <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                                @click="handleSearch">查询</el-button>
                            <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary"
                                @click="resetSearch">重置</el-button>
                            <el-button size="small" class="search-btn btn-primary" @click="confirm">确定（选中{{
                                selection.length
                                }}项）</el-button>
                            <el-button size="small" class="search-btn btn-primary" v-if="startSearch" @click="allIn">确定（结果{{
                                tableDataLength
                                }}）</el-button>
                        </div>
                    </div>
                    <div class="dialog-search-table-ctn">
                        <el-table v-el-table-infinite-scroll="tableLoad" ref="multipleTable" :header-cell-style="{ background: '#F2F6FC' }"
                            :data="tableData" @selection-change="onColumnSelect" border height="500px"
                            style="width: 100%;margin-bottom: 5px;" highlight-current-row :row-key="getRowKeys">
                            <el-table-column type="selection" width="55" reserve-selection
                                fixed="left"></el-table-column>
                            <el-table-column width="260px" prop="APCode" label="汽配编码"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="180px" prop="GoodCode" label="互换码"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="180px" prop="GoodName" label="汽配名称"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="180px" prop="AutoSerise" label="适用车型"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="120px" prop="Cate" label="汽配分类"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="100px" prop="Brand" label="品牌"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="80px" prop="Unit" label="单位"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="100px" prop="Origin" label="产地"
                                show-overflow-tooltip></el-table-column>
                            <el-table-column width="100px" prop="PackageSize" label="规格"
                                show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="播放视频" :visible.sync="videoVisible" width="1200px"
            @closed="handleVideoClose">
            <div class="video-cont">
                <video :src="openVideoUrl" width="100%" controls preload="metadata"></video>
            </div>
        </el-dialog>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import { quillEditor } from 'vue-quill-editor';
import elTableInfiniteScroll from '@/assets/js/directives/table-infinite-scroll';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
    components: {
        breadcrumb,
        quillEditor,
        ElImageViewer
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            uploadUrl: this.$util.BASE_URL + '/UploadFile/UploadSingle',
            downloadUrl: this.$util.QN_URL_BASE,
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            token:userMsg.Token,
            uploadData: {},
            pageTitle:'添加打包教程',
            showViewer: false,
            srcList: [],
            partData: {
                Id: '',
                Title: '',
                Content: '',
                GoodIds: [],
            },
            videoList:[], // 已上传到服务器的视频列表
            tempVideoList: [], // 临时存储选择的视频文件（未上传）
            goodsList: [],
            tableData: [],
            searchGoodList: [],
            visible: false,
            videoVisible: false,
            openVideoUrl:'',
            searchData: {
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                Cate: [],
                page: 1,
                limit: 20,
            },
            loading: false,
            stopFresh: true,
            typeList: [],
            brandList: [],
            selection: [],
            rules: {
                Title: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Content: [{ required: true, message: '该项必填', trigger: 'blur' }],
            },
            editorOption: {
                placeholder: '请输入内容'
            },
            startSearch:false,//控制商品弹窗搜索结果确认按钮的
            Type: '2', //不等于3就行，3是查看
            needConfirm:true
        };
    },
    computed: {
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        let id = this.$route.query.Id;
        let type = this.$route.query.Type;
        this.partData.Id = id;
        if (type == "3") {
            this.Type = type;
            this.needConfirm = false;
        }
        if (id) {
            if(type != "3"){
                this.pageTitle = "编辑打包教程";
            }else{
                this.pageTitle = "查看打包教程";
            }
            this.getVedioDetail();
        }
        ///查看大图
        window.handleImgClick = (img) => {
            this.srcList = [];
            const imgSrc = img.src;
            this.srcList.push(imgSrc); // 存储到组件数据中，供后续使用
            this.showViewer = true;
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    directives: {
        'el-table-infinite-scroll': elTableInfiniteScroll
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (!that.visible) return;
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
            }
            //ESC
            if (key === 27) {
                e.preventDefault();
                that.visible = false;
            }
        },
        getVedioDetail() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetEntpGoodsPackVideoDetail',
                    data: {
                        Id: that.partData.Id
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        const ct = res.data.Content.replace(
                            /<img src="([^"]+)"/g,
                            '<img src="$1" onclick="handleImgClick(this)" '
                        );
                        that.partData = {
                            Id: res.data.Id,
                            Title: res.data.Title,
                            Content: ct,
                            GoodIds: [],
                        };
                        if (res.data.GoodsList.length > 0) {
                            that.partData.GoodIds = res.data.GoodsList.map(x => x.EntpTempGoodsId);
                            that.goodsList = res.data.GoodsList;
                        }
                        if (res.data.VideoList.length > 0) {
                            that.videoList = res.data.VideoList;
                        }
                    }
                })
                .catch(() => { })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleCustomUpload(options) {
            if((this.tempVideoList.length + this.videoList.length) >= 5){
                this.$util.warningMsg("最多只能上传5视频!")
                return false;
            }
            const file = options.file;
            if (file) {
                const tempUrl = URL.createObjectURL(file);
                this.tempVideoList.push({
                    isTemp: true,
                    tempUrl: tempUrl,
                    file: file,
                    uid: file.uid || `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
                });
            }
        },
        handleTempVideoRemove(file) {
            const index = this.tempVideoList.findIndex(item => item.uid === file.uid);
            if (index > -1) {
                URL.revokeObjectURL(this.tempVideoList[index].tempUrl);
                this.tempVideoList.splice(index, 1);
            }
        },
        uploadSingleVideo(file) {
            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('key', 'GoodPackVideo');
                formData.append('isPrivate', false);
                for (let key in this.uploadData) {
                    formData.append(key, this.uploadData[key]);
                }

                const xhr = new XMLHttpRequest();
                xhr.open('POST', this.uploadUrl);

                for (let key in this.headerObj) {
                    xhr.setRequestHeader(key, this.headerObj[key]);
                }
                xhr.onload = () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        const response = JSON.parse(xhr.responseText);
                        if (response.errcode === 0) {
                            resolve(response);
                        } else {
                            this.$util.warningMsg('视频上传失败');
                            reject();
                        }
                    } else {
                        reject();
                    }
                };
                xhr.onerror = () => {
                    this.$util.warningMsg('网络错误，视频上传失败');
                    reject();
                };
                xhr.send(formData);
            });
        },
        // 批量上传临时视频文件
        async uploadAllTempVideos() {
            if (this.tempVideoList.length === 0) return [];
            
            const uploadPromises = this.tempVideoList.map(async (tempItem) => {
                try {
                    // 上传视频文件到后端
                    const uploadRes = await this.uploadSingleVideo(tempItem.file);
                    const videoUrl = this.downloadUrl + uploadRes.fileUrl;

                    let result = '';
                    const timestamp = Math.floor(Date.now() / 1000); // 秒级时间戳
                    if (uploadRes.fileName.length < 80) {
                        result = uploadRes.fileName + timestamp;
                    } else {
                        result = uploadRes.fileName.substring(0, 80) + timestamp;
                    }

                    // 视频名称采用时间戳形式，删除主要用名称来判断
                    const videoItem = {
                        FileUrl: uploadRes.fileUrl,
                        FileExt: "." + uploadRes.fileExt,
                        FileName: result,
                        ImgUrl: ''
                    };
                    
                    // 提取首帧
                    const imgBase64 = await this.extractVideoFirstFrame(videoUrl);
                    // 上传封面图片
                    await this.uploadImg(videoItem, imgBase64);
                    
                    return videoItem;
                } catch (err) {
                    this.$util.warningMsg(`视频 ${tempItem.file.name} 上传失败`);
                    return null;
                }
            });
            
            const results = await Promise.all(uploadPromises);
            return results.filter(item => item !== null);
        },
        uploadImg(item, imgBase64) {
            return new Promise((resolve, reject) => {
                const data = {
                    key: 'GoodPackVideo-Img',
                    isPrivate: false
                };
                let formData = new FormData();
                for (let k in data) {
                    formData.append(k, data[k]);
                }

                const fileName = 'upload_img.png'; 
                try {
                    const file = this.base64ToFile(imgBase64, fileName);
                    formData.append("file", file);
                } catch (error) {
                    this.$util.warningMsg('图片格式错误');
                    reject(error);
                    return;
                }
                
                let xhr = new XMLHttpRequest();
                xhr.open('post', this.uploadUrl);
                xhr.setRequestHeader('access-key', this.token);
                xhr.onload = () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        let res = JSON.parse(xhr.responseText);
                        item.ImgUrl = res.fileUrl;
                        resolve(item);
                    } else {
                        this.$util.warningMsg('封面上传失败');
                        reject();
                    }
                };
                xhr.onerror = () => {
                    this.$util.warningMsg('封面上传网络错误');
                    reject();
                };
                xhr.send(formData);
            });
        },
        async submitData() {
            let that = this;
            if (!that.partData.Title) {
                that.$util.warningMsg("请输入标题！");
                return false;
            }
            if (!that.partData.Content) {
                that.$util.warningMsg("请输入打包要求！");
                return false;
            }

            that.loading = true;
            try {
                // 上传所有临时视频文件到后端
                const newVideoItems = await that.uploadAllTempVideos();
                
                // 将新上传的视频合并到原有videoList
                that.videoList = [...that.videoList, ...newVideoItems];
                
                // 清空临时视频列表并释放blob链接
                that.tempVideoList.forEach(item => {
                    URL.revokeObjectURL(item.tempUrl);
                });
                that.tempVideoList = [];
                
                // 提交表单数据
                that.partData.FileList = that.videoList;
                that.$util
                .axiosPost({
                    url: '/api/EntpCustomers/EditEntpGoodsPackVideo',
                    data: that.partData,
                    hideLoading: true
                })
                .then(response => {
                    that.loading = false;
                    that.$util.successMsg('添加成功');
                    that.needConfirm = false;
                    setTimeout(() => {
                        that.$store.commit('updateNeedRefresh', true);
                        window.history.go(-1);
                    }, 100);
                })
                .catch(() => {
                    that.loading = false;
                });
            } catch (err) {
                that.$util.warningMsg(`提交失败`);
            } finally {
                that.loading = false;
            }
        },
        delUpUrl(index, isTemp = false) {
            if (isTemp) {
                URL.revokeObjectURL(this.tempVideoList[index].tempUrl);
                this.tempVideoList.splice(index, 1);
            } else {
                const realIndex = index - this.tempVideoList.length;
                if (realIndex >= 0 && realIndex < this.videoList.length) {
                    this.videoList.splice(realIndex, 1);
                }
            }
        },
        del(row) {
            var list = this.goodsList.filter(x => {
                return x.EntpTempGoodsId != row.EntpTempGoodsId;
            })
            this.goodsList = list;

            this.partData.GoodIds = list.map(x => x.EntpTempGoodsId);
        },
        onEditorFocus(e) {
        },
        onEditorChange(e) {
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最多只能上传 5 个文件`);
        },
        // 提取视频首帧作为封面方法
        extractVideoFirstFrame(videoUrl) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');

                video.crossOrigin = 'anonymous';
                video.preload = 'metadata';
                video.src = videoUrl;
                video.currentTime = 1; // 第一帧

                var canvas = document.createElement("canvas"); // 获取 canvas 对象
                const ctx = canvas.getContext("2d");
                video.oncanplay = () => {
                    canvas.width = video.clientWidth ? video.clientWidth : 320;
                    canvas.height = video.clientHeight ? video.clientHeight : 320;

                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                    let videoFirstimgsrc = canvas.toDataURL("image/png");
                                    
                    video.remove();
                    canvas.remove();
                    resolve(videoFirstimgsrc);
                };
                video.onerror = () => {
                    reject(new Error('视频加载失败，无法提取首帧'));
                    video.remove();
                    canvas.remove();
                };
            });
        },
        //Base64字符串转换为File对象
        base64ToFile(base64Str, fileName) {
            const arr = base64Str.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], fileName, { type: mime });
        },
        openVisible() {
            this.visible = true;
            this.startSearch = false;
            this.selection = [];
            this.tableData = [];
            this.searchData.page = 1;
            // 防止多次点击
            if (!this.loading) {
                this.getTableData();
            }
        },
        closeVisible() {
            this.visible = false;
            this.resetSearch();
        },
        openVideoVisible(data) {
            this.openVideoUrl = data;
            this.videoVisible = true;
        },
        closeVideoVisible() {
            this.videoVisible = false;
        },
        handleVideoClose() {
            const videoElement = document.querySelector('.video-cont video');
            if (videoElement) {
                videoElement.pause(); // 暂停播放
                videoElement.currentTime = 0; // 重置播放进度
            }
        },
        getRowKeys(row) {
            return row.EntpTempGoodsId;
        },
        tableLoad() {
            if (!this.stopFresh) {
                if (this.tableData && this.tableData.length > 0) this.searchData.page += 1;
                else this.searchData.page = 1;
                this.getTableData();
            }
        },
        handleSearch() {
            this.tableData = [];
            this.selection = [];
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            if(!this.startSearch){
                this.startSearch = true;
            }
            // 防止多次点击
            if (!this.loading) {
                this.getTableData();
            }
        },
        getTableData() {
            return new Promise(resolve => {
                if (this.searchData.page == 1) {
                    this.searchParams = { ...this.searchData };
                } else {
                    this.searchParams.page = this.searchData.page;
                }
                this.loading = true;
                this.stopFresh = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetGoodsListForOrder_V2',
                        data: this.searchParams,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;

                        this.tableDataLength = res.count;
                        if (!data) {
                            if (this.searchData.page == 1) this.tableData = [];
                            return;
                        }

                        let list = [...this.tableData, ...data];
                        const maps = new Map();
                        list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                        this.tableData = list;
                        this.stopFresh = data.length < this.searchData.limit;
                        resolve(this.tableData);
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            });
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                Cate: [],
                page: 1,
                limit: 20,
            };
        },
        confirm() {
            var list = this.selection.filter(x => {
                return !this.partData.GoodIds.includes(x.EntpTempGoodsId);
            })
            this.goodsList = [...this.goodsList, ...list];

            var ids = list.map(x => x.EntpTempGoodsId);
            this.partData.GoodIds = [...this.partData.GoodIds, ...ids]
            this.closeVisible();
        },
        allIn() {
            if(this.tableData.length == this.tableDataLength){
                var list = this.tableData.filter(x => {
                    return !this.partData.GoodIds.includes(x.EntpTempGoodsId);
                })
                this.goodsList = [...this.goodsList, ...list];
    
                var ids = list.map(x => x.EntpTempGoodsId);
                this.partData.GoodIds = [...this.partData.GoodIds, ...ids]
                this.closeVisible();
            }else{
                this.searchParams = { ...this.searchData };
                this.searchParams.limit = 50;

                if(this.searchParams.page == 1){
                    this.tableData = [];
                }
                this.loading = true;
                this.stopFresh = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoods/GetGoodsListForOrder_V2',
                        data: this.searchParams,
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;

                        if (!data) {
                            if (this.searchData.page == 1) this.tableData = [];
                            return;
                        }

                        let list = [...this.tableData, ...data];
                        const maps = new Map();
                        list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                        this.tableData = list;
                        this.stopFresh = this.tableData.length == this.tableDataLength;

                        if(!this.stopFresh){
                            this.searchData.page++;
                        }
                        this.allIn();
                    })
                    .catch(e => {
                        this.loading = false;
                    });
            }
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => { });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .catch(() => { });
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        closeViewer() {
            this.showViewer = false;
        },
        // 废弃原有上传相关方法（不再使用）
        opUpLoadChange() {},
        onUploadErr(){},
        onUploadPreview(file) {},
        onUploadSuccess() {}
    }
};
</script>


<style lang="less">
.price-point {
    .el-form-item {
        margin-bottom: 10px !important;
    }
}

.add-accessories {
    .form-line .form-item .el-form-item__label {
        white-space: nowrap;
    }

    .el-form-item {
        margin-bottom: 16px;
    }

    .section .middle textarea {
        height: 100%;
    }
}
</style>

<style lang="less" scoped>
.business-content-main {
    display: flex;
    flex-direction: column;
    height: 100%;

    .btns {
        // text-align: right;
        padding: 4px;
        width: 100%;
    }
}

.videoimg {
    width: 200px;
    height: 100px;
    border: 1.5px solid rgb(238, 237, 237);
    color: rgb(238, 237, 237);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.el-icon-error {
    position: absolute;
    font-size: 20px;
    right: -10px;
    top: -10px;
    color: #9d9d9d;
}

.videoimg video {
    width: 200px;
    height: 100px;
    border-radius: 5px;
}

/deep/.el-upload--picture-card {
    background-color: #ffffff;
    border: none;
    border-radius: 0;
    -webkit-box-sizing: unset;
    box-sizing: unset;
    width: 66px;
    height: auto;
    line-height: 40px;
}

/deep/.el-select__tags {
    top: 38%;
}

/deep/.form-item .el-table__header-wrapper th {
    padding: 0;
    line-height: 30px;
}

.form-main {
    margin-top: 5px;
    width: 100%;
    display: flex;
    flex-direction: column;

    .form-line {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .form-item {
        width: 80%;

        .el-input {
            width: 80%;
        }
    }
    /deep/.el-form-item__label{
        font-weight: bold;
    }
    .form-item-content {
        height: 340px;

        
        .quill-editor {
            width: 100%;
            height: 240px;
        }

        ///默认样式影响到富文本的内容样式了
        /deep/ strong {
            font-weight: 700;
        }

        /deep/ em {
            font-style: italic !important;
        }

        .ql-snow {
            border: none;
        }
    }
}
.check-titile{
    font-weight: bold;
    width: 100%;
    font-size: 20px;
}
.check-content{
    min-height: 240px;
    max-height: 800px;
    width: 1500px;
    padding: 10px;
    overflow: auto;
    border: #ebeef5 1px solid;
    /deep/ img{
        max-width: 300px;
    }
}
.check-video{
    width: 100%;
}
.search-left {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

/deep/.el-table__row td {
    padding: 5px 0;
    line-height: 30px;
}

.search-name {
    width: 70px;
}

.search-left .search-item {
    width: 200px;
    margin: 0 10px;
}

.search-left button {
    height: 30px;
    line-height: 10px;
}

.video-cont {
    width: 100%;
    min-height: 200px;
    max-height: 800px;
    display: flex;
    justify-content: center;
}
.video-item{
    /deep/.el-form-item__content{
        display: flex;
        overflow-y: auto;
        height: 130px;
        align-items: center;
        .videoimg{
            margin-left: 20px;
        }
    }
}
</style>
